'use strict';
const angular = require('angular');

export class AccountTreeComponent {
  /*@ngInject*/
  constructor(SettingsService) {
    this.SettingsService = SettingsService;

    this.treeOptions = {
      nodeChildren: "subAccounts",
      dirSelectable: true,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    };

    this.flattedAccounts = [];

    this.SettingsService.getByName({name: "chart-of-accounts"}, coa => {
      this.coa = coa.data;

      this.coa.forEach(headAccount => {
        this.flattedAccounts.push({
          code: headAccount.code,
          accounts: headAccount.account,
          description: headAccount.description
        });

        if (headAccount.hasOwnProperty('subAccounts')) {
          headAccount.subAccounts.forEach(subAccount => {

            let accounts = [headAccount.account, subAccount.account].join(':');

            this.flattedAccounts.push({
              code: subAccount.code,
              accounts: accounts,
              description: subAccount.description
            });

            if (subAccount.hasOwnProperty('subAccounts')) {
              subAccount.subAccounts.forEach(subSubAccount => {

                let accounts = [headAccount.account, subAccount.account, subSubAccount.account].join(':');

                this.flattedAccounts.push({
                  code: subSubAccount.code,
                  accounts: accounts,
                  description: subSubAccount.description
                });
              });
            }
          });
        }
      });
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {

    let code = this.node.code;

    let account = this.flattedAccounts.find(acc => {
      return acc.code == code
    });

    this.close({$value: account});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.accountTree', [])
  .component('accountTree', {
    template: require('./account-tree.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: AccountTreeComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/account-tree/account-tree.component.js